export const revisionCards = [
  {
    id: "1",
    topText: "Boosting Exam Performance",
    bottomText: "IQify students are <span className='bg-yellow-300 px-2 py-1 rounded'>3×</span> more likely to score top marks in logic and verbal reasoning tests after 12 weeks of brain training."
  },
  {
    id: "2",
    topText: "Building Cognitive Skills for Life",
    bottomText: "Studies show IQify users increase working memory and pattern recognition speed by <span className='bg-yellow-300 px-2 py-1 rounded'>35%</span>, key indicators for academic and professional success."
  },
  {
    id: "3",
    topText: "Achieving Academic Milestones",
    bottomText: "Over <span className='bg-yellow-300 px-2 py-1 rounded'>70%</span> of IQify students report achieving higher grades, including 100% scores in subjects like GCSE Maths and Verbal Reasoning."
  },
  {
    id: "4",
    topText: "Training the Professional Mind",
    bottomText: "Adult learners using IQify show a <span className='bg-yellow-300 px-2 py-1 rounded'>40%</span> improvement in strategic planning, creativity under pressure, and solution-focused thinking — critical skills for career growth."
  },
  {
    id: "5",
    topText: "Turning Potential Into Results",
    bottomText: "Students and professionals who engage with IQify’s brain training for at least 20 minutes a day outperform peers in competitive assessments and job interviews by <span className='bg-yellow-300 px-2 py-1 rounded'>25%</span>."
  }
];
